module.exports = __webpack_public_path__ + "img/logo.cbf1d3c8.png";